export const SuperThankfulLocked = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="52"
    height="52"
    viewBox="0 0 52 52"
  >
    <g
      id="Super_Thankful_Badge_-_Locked"
      data-name="Super Thankful Badge - Locked"
      transform="translate(1 1)"
    >
      <path
        id="Path_2103"
        data-name="Path 2103"
        d="M25,0A25,25,0,1,1,0,25,25,25,0,0,1,25,0Z"
        fill="transparent"
        stroke="#666"
        strokeLinecap="round"
        strokeWidth="2"
      />
      <g id="SJ-Icon-B_Donate_Red_RGB" transform="translate(9.523 11.57)">
        <path
          id="Path_2211"
          data-name="Path 2211"
          d="M16.718,47.468H1.709a.7.7,0,0,1,0-1.406H16.718a7.686,7.686,0,0,0,5.47-2.265l6.284-6.284a1.336,1.336,0,0,0-1.748-.312l-7.134,4.37a3.534,3.534,0,0,1-2.746.4L11.43,40.519a1.172,1.172,0,0,1-.049-2.25l5.685-1.792a1.059,1.059,0,0,0,.7-1.307H10.706a6.836,6.836,0,0,0-4.14,1.406l-4.429,3.4a.7.7,0,1,1-.856-1.115l4.429-3.4a8.248,8.248,0,0,1,5-1.7h7.221A1.176,1.176,0,0,1,19,34.457a2.465,2.465,0,0,1-1.507,3.362l-4.919,1.55,4.637,1.242a2.114,2.114,0,0,0,1.648-.239L25.989,36a2.743,2.743,0,0,1,3.8.956,1.167,1.167,0,0,1-.186,1.411l-6.423,6.423A9.082,9.082,0,0,1,16.718,47.468Z"
          transform="translate(0 -17.409)"
          fill="#666"
        />
        <path
          id="Path_2215"
          data-name="Path 2215"
          d="M31,26.218l-.911,5.308a.568.568,0,0,0,.823.6l4.767-2.507,4.767,2.507a.568.568,0,0,0,.823-.6l-.911-5.308,3.857-3.759a.567.567,0,0,0-.314-.967l-5.329-.774-2.383-4.829a.567.567,0,0,0-1.017,0l-2.383,4.829-5.33.774a.567.567,0,0,0-.314.967ZM33.243,21.8a.566.566,0,0,0,.426-.31l2.007-4.066,2.007,4.066a.566.566,0,0,0,.427.31l4.487.652-3.247,3.165a.567.567,0,0,0-.163.5l.767,4.469-4.013-2.11a.568.568,0,0,0-.528,0L31.4,30.585l.767-4.469a.567.567,0,0,0-.163-.5l-3.247-3.165Z"
          transform="translate(-20.142 -18.772)"
          fill="#666"
        />
      </g>
    </g>
  </svg>
);

export const SuperThankfulUnlocked = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="52"
    height="56"
    viewBox="0 0 52 56"
  >
    <defs>
      <linearGradient
        id="linear-gradient"
        x1="0.5"
        x2="0.5"
        y2="1"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="#d11947" />
        <stop offset="1" stopColor="#8d0034" />
      </linearGradient>
    </defs>
    <g
      id="Super_Thankful_Badge_-_Unlocked"
      data-name="Super Thankful Badge - Unlocked"
      transform="translate(-15 1355)"
    >
      <g id="Group_2666" data-name="Group 2666" transform="translate(16 -1350)">
        <path
          id="Path_2103"
          data-name="Path 2103"
          d="M25,0A25,25,0,1,1,0,25,25,25,0,0,1,25,0Z"
          stroke="#8d0034"
          strokeLinecap="round"
          strokeWidth="2"
          fill="url(#linear-gradient)"
        />
        <g id="SJ-Icon-B_Donate_Red_RGB" transform="translate(9.523 11.57)">
          <path
            id="Path_2211"
            data-name="Path 2211"
            d="M16.718,47.468H1.709a.7.7,0,0,1,0-1.406H16.718a7.686,7.686,0,0,0,5.47-2.265l6.284-6.284a1.336,1.336,0,0,0-1.748-.312l-7.134,4.37a3.534,3.534,0,0,1-2.746.4L11.43,40.519a1.172,1.172,0,0,1-.049-2.25l5.685-1.792a1.059,1.059,0,0,0,.7-1.307H10.706a6.836,6.836,0,0,0-4.14,1.406l-4.429,3.4a.7.7,0,1,1-.856-1.115l4.429-3.4a8.248,8.248,0,0,1,5-1.7h7.221A1.176,1.176,0,0,1,19,34.457a2.465,2.465,0,0,1-1.507,3.362l-4.919,1.55,4.637,1.242a2.114,2.114,0,0,0,1.648-.239L25.989,36a2.743,2.743,0,0,1,3.8.956,1.167,1.167,0,0,1-.186,1.411l-6.423,6.423A9.082,9.082,0,0,1,16.718,47.468Z"
            transform="translate(0 -17.409)"
            fill="#fff"
          />
          <path
            id="Path_2215"
            data-name="Path 2215"
            d="M31,26.218l-.911,5.308a.568.568,0,0,0,.823.6l4.767-2.507,4.767,2.507a.568.568,0,0,0,.823-.6l-.911-5.308,3.857-3.759a.567.567,0,0,0-.314-.967l-5.329-.774-2.383-4.829a.567.567,0,0,0-1.017,0l-2.383,4.829-5.33.774a.567.567,0,0,0-.314.967ZM33.243,21.8a.566.566,0,0,0,.426-.31l2.007-4.066,2.007,4.066a.566.566,0,0,0,.427.31l4.487.652-3.247,3.165a.567.567,0,0,0-.163.5l.767,4.469-4.013-2.11a.568.568,0,0,0-.528,0L31.4,30.585l.767-4.469a.567.567,0,0,0-.163-.5l-3.247-3.165Z"
            transform="translate(-20.142 -18.772)"
            fill="#fff"
          />
        </g>
      </g>
      <g id="Group_2803" data-name="Group 2803" transform="translate(49 -1355)">
        <circle
          id="Ellipse_55"
          data-name="Ellipse 55"
          cx="8.5"
          cy="8.5"
          r="8.5"
          fill="#008a1c"
        />
        <g
          id="Check_Mark_-_S"
          data-name="Check Mark - S"
          transform="translate(4 5.29)"
        >
          <path
            id="Check_Mark_-_S-2"
            data-name="Check Mark - S"
            d="M9.381,2.22a.442.442,0,0,0-.639,0L3.572,7.414,1.262,5.136a.442.442,0,0,0-.631,0,.459.459,0,0,0,0,.639l2.63,2.6a.483.483,0,0,0,.32.131.459.459,0,0,0,.32-.139l5.481-5.53A.451.451,0,0,0,9.381,2.22Z"
            transform="translate(-0.502 -2.083)"
            fill="#fff"
          />
        </g>
      </g>
    </g>
  </svg>
);
